import React from 'react';

const Accreditation = () => {
  return (
    <section className="relative px-6 py-20 overflow-hidden bg-gradient-to-r from-blue-50 via-purple-50 to-green-50 md:px-12">
      {/* SVG wave pattern */}
      <div className="absolute inset-0 z-0">
        <svg viewBox="0 0 1440 320" className="w-full h-full opacity-5">
          <path fill="#3b82f6" fillOpacity="0.1" d="M0,192L1440,320L1440,320L0,320Z"></path>
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto text-center max-w-7xl">
        <h2 className="mb-4 text-4xl font-extrabold text-gray-800">Global Accreditations</h2>
        <p className="max-w-2xl mx-auto mb-12 text-lg text-gray-600">
          Blessed Montessori is proudly recognized by global institutions committed to quality education and lifelong learning.
        </p>

        {/* Logos Grid */}
        <div className="grid items-center justify-center grid-cols-2 gap-10 sm:grid-cols-3 md:grid-cols-4">
          {/* Placeholder or use real logo URLs below */}
          <div className="transition transform hover:scale-105">
            <img
              src="https://i.imgur.com/v3uID2h.png" // UNESCO-style logo
              alt="UNESCO"
              className="object-contain h-12 mx-auto"
            />
            <p className="mt-2 text-sm text-gray-500">UNESCO Partner</p>
          </div>

          <div className="transition transform hover:scale-105">
            <img
              src="https://i.imgur.com/V7RZuw2.png" // Cambridge-style
              alt="Cambridge"
              className="object-contain h-12 mx-auto"
            />
            <p className="mt-2 text-sm text-gray-500">Cambridge Aligned</p>
          </div>

          <div className="transition transform hover:scale-105">
            <img
              src="https://i.imgur.com/OYk8ZzE.png" // Montessori council-style
              alt="Montessori"
              className="object-contain h-12 mx-auto"
            />
            <p className="mt-2 text-sm text-gray-500">Montessori Certified</p>
          </div>

          <div className="transition transform hover:scale-105">
            <img
              src="https://i.imgur.com/yTUB1Tm.png" // WAEC-style logo
              alt="WAEC"
              className="object-contain h-12 mx-auto"
            />
            <p className="mt-2 text-sm text-gray-500">WAEC Approved</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accreditation;
